(function ($, Global) {
    function SubscriptionModel() {
        // Déclaration class objet
    }

	SubscriptionModel.prototype.commande = function (data, $form, callback) {
		$.ajaxPost('/ajax/subscriptions/commande', data)
			.done(function (result) {
				Global.ajaxCallback({
					results: result,
					form: $form,
					success: callback
				});
			});
	}

	SubscriptionModel.prototype.checkTva = function (data, callback) {
		$.ajaxPost('/ajax/subscriptions/checktva', data)
			.done(function (result) {
				Global.ajaxCallback({
					results: result,
					success: callback
				});
			});
	}

	SubscriptionModel.prototype.simulateur = function (data, callback) {
		$.ajaxPost('/ajax/subscriptions/simulateur', data)
			.done(function (result) {
				Global.ajaxCallback({
					results: result,
					success: callback
				});
			});
	}

	SubscriptionModel.prototype.extension = function (data, $form, callback) {
		$.ajaxPost('/ajax/subscriptions/extension', data)
			.done(function (result) {
				Global.ajaxCallback({
					results: result,
					form: $form,
					success: callback
				});
			});
	}

    SubscriptionModel.prototype.subscribeNewsletter = function (data, $form, callback) {
        $.ajaxPost('/ajax/form/newsletter', data)
            .done(function (result) {
                Global.ajaxCallback({
                    results: result,
                    form: $form,
                    success: callback
                });
            });
    }

    SubscriptionModel.prototype.unsubscribe = function (data, callback) {
        $.ajaxPost('/ajax/unsub/abonne', data)
            .done(function (result) {
                Global.ajaxCallback({
                    results: result,
                    success: callback
                })
            });
    }

	Global.SubscriptionModel = SubscriptionModel;
}(jQuery, window));